<div class="section">
    <div class="header section-title" [ngClass]="{'right':section.LabelAlignment == 'Right'}">{{section.SectionTitle}}</div>
    <div class="section-body">
      <ng-container *ngFor="let item of children" [appRenderNode]="item"> </ng-container>
    </div>
  </div>